module.exports = "https://cdn.dove.it/_next/static/public/assets/landings/franchising/vantaggio_portali.67017a8a1694ecd3d9ba7867e70c249e.jpg";